import * as React from 'react';

import styles from './styles.module.scss';

type Props = {
	secondaryOption: Nullable<string>;
	setSecondaryOption: (value: Nullable<string>) => void;
};

const TextSecondary: React.FC<Props> = (props) => {
	const { secondaryOption, setSecondaryOption } = props;
	const onValueChange = React.useCallback((value: React.ChangeEvent<HTMLInputElement>) => {
		setSecondaryOption(value.target.value);
	}, [setSecondaryOption]);

	return (
		<div className={styles['text-secondary']}>
			<input className="form-control" onChange={onValueChange} placeholder="Enter Text" type="text" value={secondaryOption ?? undefined} />
		</div>
	);

};

export default React.memo(TextSecondary);
